import dynamic from 'next/dynamic';

const LongformGalleryComponent = dynamic(
  () => import(/* webpackChunkName: "boatWebCarouselLongformGalleryVariant" */ './LongformGallery')
);

const LongformGallery = {
  VariantComponent: LongformGalleryComponent,
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'longformGallery'
  })
};

export default LongformGallery;
